import React, { ChangeEvent } from 'react';
import Section from '../models/Section';
import Category from '../models/Category';
import CategoryLink from './CategoryLink';

interface SectionsListProps {
  sections: Section[];
  searchable?: boolean;
  sectionsClickable?: boolean;
}

interface SectionsListState {
  searchText: string;
}

export default class SectionsList extends React.Component<SectionsListProps, SectionsListState> {
  constructor(props: SectionsListProps) {
    super(props);
    this.state = {
      searchText: '',
    };
  }

  render() {
    return (
      <div>
        {this.props.searchable && (
          <div className="menu-item search">
            <span className="search-icon gik-icon-v2 icon-v2-search"></span>
            <input
              type="text"
              name="search"
              autoComplete="off"
              value={this.state.searchText}
              onChange={this._onSearchTextChange}
              placeholder={'Search tags'}
            />
          </div>
        )}
        {this.state.searchText && this._renderSearchResults()}
        {!this.state.searchText && this._renderSections()}
      </div>
    );
  }

  _renderSearchResults() {
    // TODO: remove eslint-disable-next-line
    // eslint-disable-next-line
    const categories = ([].concat.apply(
      [],
      this.props.sections.map(s => s.categories)
    ) as Category[])
      .filter(category => category.name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) >= 0)
      .filter((category, index, array) => array.findIndex(v => v.name === category.name) === index); // remove duplicates

    return (
      <div className="search-results">
        {categories.map(category => (
          <CategoryLink key={category.name} className="menu-item" category={category} />
        ))}
      </div>
    );
  }

  _renderSections() {
    return this.props.sections.map(section => (
      <div key={section.titleCategory.name}>
        {!this.props.sectionsClickable && (
          <div className="menu-item section unclickable">
            <p>{section.titleCategory.name.toUpperCase()}</p>
          </div>
        )}
        {this.props.sectionsClickable && (
          <CategoryLink
            key={section.titleCategory.name.toUpperCase()}
            className="menu-item section"
            category={section.titleCategory}
            upperCase={true}
          />
        )}
        {section.categories.map(category => (
          <CategoryLink key={category.name} className="menu-item section-child" category={category} />
        ))}
      </div>
    ));
  }

  _onSearchTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchText: event.target.value });
  };
}
